import App from "./App.svelte";

const container = document.querySelector("#catalog-search");

const app = new App({
    target: container
});
